import fileSaver from "file-saver";

export class FileService {
  public static downloadFile(data: Blob, filename: string) {
    const reader: any = new FileReader();

    reader.readAsDataURL(data);
    reader.onload = () => {
      fileSaver.saveAs(reader.result, filename);
    };
  }
  public static printPdf(data: Blob) {
    const iframe: any = document.createElement("iframe");
    iframe.src = URL.createObjectURL(data);
    iframe.style.display = "none";
    iframe.onload = () =>
      setTimeout(() => {
        iframe.focus();
        iframe.contentWindow.print();
      }, 0);
    document.body.appendChild(iframe);
  }
  public static openPdfInNewTab(data: Blob, tab?: Window | null) {
    const fileURL = URL.createObjectURL(data);
    if (!tab) {
      return window.open(fileURL);
    }

    tab.location.href = fileURL;
  }
}
